module.exports = __webpack_public_path__ + "static/media/FinalHowitWorksBck.182a6212.png";